import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { createPortal } from "react-dom";

const containerId = 'magic-popup-container';

function MagicPopup(props) {
  let container = document.getElementById(containerId);

  if (container === null) {
    container = document.createElement('div');
    container.id = containerId;
    document.body.appendChild(container);
  }

  return createPortal(
    <Fragment>
      <style>
        {`.popup-wrapper { font-family: "Cerebri Sans", Arial, san-serif; }`}
      </style>
      <div className="popup-wrapper tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-fixed tw-flex tw-items-center tw-justify-center tw-bg-white tw-bg-opacity-40 tw-z-50 tw-backdrop-blur-sm">
        <div className="tw-w-[500px] tw-bg-white tw-overflow-hidden tw-border-2 tw-border-brand-green-light tw-border-solid tw-rounded-md tw-flex-col tw-drop-shadow-xl">
          {props.title ? (
            <div className="tw-p-5 tw-pt-3 tw-pb-3 tw-text-2xl tw-border-b-2 tw-border-solid tw-border-gray-200">{props.title}</div>
          ) : null}
          <div className="tw-p-5 tw-pt-7 tw-pb-7 tw-min-h-32 tw-text-[17px]">{props.children}</div>
          <div className="tw-p-2 tw-bg-gray-100 tw-flex tw-flex-row tw-justify-end tw-gap-2">
            {props.resolveButtonText && props.onResolve ? (
              <div className="tw-text-white tw-text-center tw-font-bold tw-uppercase tw-bg-brand-green-light hover:tw-opacity-90 tw-p-4 tw-min-w-32 tw-rounded-md tw-cursor-pointer tw-select-none tw-col-start-2" onClick={props.onResolve}>
                {props.resolveButtonText}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Fragment>,
    container,
  );
}

MagicPopup.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  resolveButtonText: PropTypes.string,
  rejectButtonText: PropTypes.string,
  onResolve: PropTypes.func,
  onReject: PropTypes.func,
};

MagicPopup.defaultProps = {
  children: null,
  title: null,
  resolveButtonText: null,
  rejectButtonText: null,
  onResolve: null,
  onReject: null,
};

export default MagicPopup;
